import { z } from 'zod';
export var Language;
(function (Language) {
    Language["NB"] = "NB";
    Language["NN"] = "NN";
    Language["EN"] = "EN";
    Language["SV"] = "SV";
    Language["VI"] = "VI";
    Language["JA"] = "JA";
    Language["DE"] = "DE";
    Language["ES"] = "ES";
    Language["FR"] = "FR";
    Language["CA"] = "CA";
    Language["ZH"] = "ZH";
})(Language || (Language = {}));
export const languageSchema = z.nativeEnum(Language);
